import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import Sticky from 'react-sticky-el';
import useHandbookMenuService from '../handbookMenuService';
import { handbookMenuSx, handbookMenuScrollSx, handbookTabsSx } from './handbookMenuStyles';

export const MAX_SM_WIDTH = 992;

const HandbookMenu = ({ tableContent }: any) => {
  const { content, loading, setTableContent } = useHandbookMenuService();

  useEffect(() => {
    setTableContent(tableContent);
    // Suppressed warnings because we only need to call useEffect callback after updating tableContent.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableContent]);

  return loading ? null : (
    <Box sx={handbookMenuSx}>
      <Sticky
        stickyClassName="sticky-menu"
        disabled={window.innerWidth < MAX_SM_WIDTH}
        hideOnBoundaryHit={false}
        boundaryElement=".handbook-content"
        bottomOffset={100}
        topOffset={-103}
      >
        {content ? (
          <Box sx={handbookMenuScrollSx}>
            <Box sx={handbookTabsSx}>{content}</Box>
          </Box>
        ) : null}
      </Sticky>
    </Box>
  );
};

export default HandbookMenu;
